import * as React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props}/>;
});

export default function Bs4NewTab(props) {

  // const link = Bs4MainDispatch.getUrlPath(props.link);

  const handleClick = (event) => {
    if (props.onClose) props.onClose(event);
  }
  
  return (
    <Dialog fullScreen open={Boolean(props.link)} TransitionComponent={Transition}>
      <Stack sx={{height: '100%'}} direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={0.5}>
        <Stack sx={{width: '100%'}} direction="row" justifyContent='space-between' alignItems="center" spacing={1}>
          <IconButton onClick={handleClick}><i className="fa-solid fa-arrow-left"/></IconButton>
          {/* <Typography noWrap>{props.link}</Typography> */}
        </Stack>
        <iframe src={props.link} width="100%" style={{flex: 1}} border={"0"}></iframe>
      </Stack>
    </Dialog>
  );
}
